import { useForm } from "react-hook-form"
import { useNavigate } from "react-router"
import { api, ApiError } from "../../../lib/api"
import appName from "../../../lib/appName"
import "../../../styles/auth.scss"

type FormValues = {
  name: string
}

export default function OnboardingPage() {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>()

  const onSubmit = async (data: FormValues) => {
    try {
      await api.post("/organizations", { organization: data })
      navigate("/")
    } catch (err) {
      const { data: errData } = err as ApiError
      const messages = errData.errors ?? ["エラーが発生しました"]
      setError("root", { message: messages.join(", ") })
    }
  }

  return (
    <div className="auth-layout">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo.png" alt={appName()} className="auth-logo__img" />
        </div>

        <h1 className="auth-title">組織を作成する</h1>
        <p className="auth-subtitle">
          {appName()}を使うには組織が必要です。<br />
          あなたが管理者となる組織名を入力してください。
        </p>

        {errors.root && (
          <div className="error-banner">{errors.root.message}</div>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <label>組織名</label>
            <input
              type="text"
              placeholder="例：株式会社〇〇"
              className={errors.name ? "error" : ""}
              {...register("name", { required: "組織名を入力してください" })}
            />
            {errors.name && <p className="field-error">{errors.name.message}</p>}
          </div>

          <button type="submit" className="btn-primary" disabled={isSubmitting}>
            {isSubmitting ? "作成中..." : "組織を作成してはじめる"}
          </button>
        </form>
      </div>
    </div>
  )
}
